// extracted by mini-css-extract-plugin
export default {"modalHeader":"modalHeader__YdmxQ","modalBody":"modalBody__gwkSk","modalBodyWrapper":"modalBodyWrapper__Jd82z","modal":"modal__Hrkp2","wrapper":"wrapper__dbCNZ","isShownAsOverlay":"isShownAsOverlay__oYXed","inner":"inner__xYB5o"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"modalHeader\":\"modalHeader__YdmxQ\",\"modalBody\":\"modalBody__gwkSk\",\"modalBodyWrapper\":\"modalBodyWrapper__Jd82z\",\"modal\":\"modal__Hrkp2\",\"wrapper\":\"wrapper__dbCNZ\",\"isShownAsOverlay\":\"isShownAsOverlay__oYXed\",\"inner\":\"inner__xYB5o\"}";
        // 1787130557297
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  